import i18n, { TFunction } from 'i18next'
import HttpApi from 'i18next-http-backend'
import { initReactI18next } from 'react-i18next'
import intervalPlural from 'i18next-intervalplural-postprocessor'

import { BrowserStorage, Instance, Languages, NS } from '@const/consts'
import * as Sentry from '@sentry/browser'

const instance = window.location.hostname.match(
  /com.br|ilsbrasil.com|ils-brasil.com/g
)?.[0]
  ? Instance.BR
  : window.location.hostname.match(/global|ru|africa/g)?.[0] ??
    window.localStorage.getItem(BrowserStorage.INSTANCE) ??
    Instance.GLOBAL;
window.localStorage.setItem(BrowserStorage.INSTANCE, instance);

const isRussia = instance === Instance.RU
const allLangs = [Languages.EN, Languages.RU, Languages.PT]
const langsWithoutRussian = [Languages.EN, Languages.PT]
const lngFromLS = window.localStorage.getItem(BrowserStorage.LANGUAGE) ?? Languages.EN

let translates: string[] = langsWithoutRussian

if (isRussia) {
  translates = allLangs
}

i18n
  .use(HttpApi)
  .use(initReactI18next)
  .use(intervalPlural)
  .init({
    lng: lngFromLS,
    fallbackLng: translates,
    preload: translates,
    ns: NS,
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json'
    },
    debug: false,

    react: {
      nsMode: 'default'
    },

    interpolation: {
      escapeValue: false
    }
  })
  .catch((err: TFunction) => {
    const errorText = 'i18n error'
    const errorLevel = 'fatal'
    const errorInfo = { err }

    Sentry.withScope((scope: Sentry.Scope) => {
      scope.setLevel(errorLevel)
      scope.setExtras(errorInfo)
      Sentry.captureException(new Error(errorText))
    })
  })

export default i18n
